class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll('.product-gallery__slide');
    this.thumbs = this.querySelectorAll('.product-gallery__thumb');
    this.currentIndex = 0;
  }

  connectedCallback() {
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    document.addEventListener('variant:change', (e) => {
      const variant = e.detail?.variant;
      const mediaId = variant && variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;
      const slide = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (slide) {
        this.goTo(parseInt(slide.dataset.index, 10));
      }
    });

    this.setupSwipe();
  }

  goTo(index) {
    if (index === this.currentIndex || index < 0 || index >= this.slides.length) return;

    this.slides[this.currentIndex].classList.remove('is-active');
    this.thumbs[this.currentIndex]?.classList.remove('is-active');

    this.currentIndex = index;

    this.slides[this.currentIndex].classList.add('is-active');
    this.thumbs[this.currentIndex]?.classList.add('is-active');

    this.thumbs[this.currentIndex]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }

  setupSwipe() {
    let startX = 0;
    const main = this.querySelector('.product-gallery__main');
    if (!main) return;

    main.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    main.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.goTo(this.currentIndex + 1);
        } else {
          this.goTo(this.currentIndex - 1);
        }
      }
    }, { passive: true });
  }
}

customElements.define('product-gallery', ProductGallery);
